
















































import {
  computed,
  defineComponent,
  onMounted,
  ref,
  useRoute,
} from "@nuxtjs/composition-api";
import BlogShowcase from "~/server/blog/BlogShowcase.vue";

interface Post {
  title: string;
  date: string;
  content: string;
  slug: string;
  author: string;
  tags: string[];
  categories: string[];
  featured_image: string;
  likes: number;
}

export default defineComponent({
  name: "BlogPost",
  components: {
    BlogShowcase,
  },
  setup() {
    const post = ref<Post | null>(null);
    const error = ref<Error | null>(null);
    const likes = ref(0);
    const route = useRoute();

    const slug = computed(() => route.value.params.slug);

    const fetchPost = async () => {
      try {
        const response = await fetch(`/api/posts/${slug.value}`);
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        const data = await response.json();
        post.value = data as Post;
        await fetchLikes();
      } catch (err) {
        error.value = err as Error;
        console.error("Error fetching post:", err);
      }
    };

    const formatDate = (dateString: string) => {
      const date = new Date(dateString);
      const correctedDate = new Date(
        date.getTime() + date.getTimezoneOffset() * 60_000
      );
      const options: Intl.DateTimeFormatOptions = {
        year: "numeric",
        month: "long",
        day: "numeric",
      };
      return correctedDate.toLocaleDateString(undefined, options);
    };

    const fetchLikes = async () => {
      try {
        const response = await fetch(`/api/posts/${slug.value}/likes`);

        if (response.ok) {
          const data = await response.json();
          likes.value = data.likes;
        }
      } catch (err) {
        console.error("Error fetching likes:", err);
      }
    };

    const handleLike = async () => {
      try {
        const response = await fetch(`/api/posts/${slug.value}/like`, {
          method: "POST",
        });
        const data = await response.json();

        if (response.ok) {
          likes.value = data.likes;
        } else {
          console.error("Failed to like post:", response.statusText);
        }
      } catch (err) {
        console.error("Error liking post:", err);
      }
    };

    onMounted(fetchPost);

    return {
      post,
      error,
      likes,
      formatDate,
      handleLike,
    };
  },
});
